
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M96.2 57.1c-2.1-1.4-4.4-2.5-6.7-3.3-8-2.8-10.1-2.1-14.3 5.4-3.1 5.5-5.8 11.1-8.9 16.6-1.3 2.4-2.8 4.8-4.8 6.7C51.1 92.8 38 94.6 24.1 93.7c4.2-2.4 7-6 9.4-10.1 3.1-5.4 6.2-10.9 9.1-16.5 3.2-6.1 7.7-10.8 14-13.7 1.1-.5 2.1-.9 3.2-1.3-.1-.1-.1-.2-.2-.3h-.9C43.6 54 29.4 58.6 16.6 67.1c-5.6 3.6-10.5 8-14 13.8-4.9 8.2-2.7 16.5 5.8 20.8 2.9 1.5 6.1 2.6 9.2 3.4 10.1 2.4 20.3 1.8 30.4 0 14-2.5 27.3-7.2 39.1-15.3 5.6-3.8 10.7-8.3 13.8-14.6 3.5-6.9 1.8-13.7-4.7-18.1z"}}),_c('path',{attrs:{"opacity":".7","d":"M124.8 21.4c-21.1 0-42.3-.1-63.4.1-5.9 0-11.9.5-17.8 1.4-9.5 1.4-18.4 4.8-25.7 11.3-3.7 3.2-6.6 7.1-8.4 12 1.1.1 1.8.2 2.6.2 22.9 0 45.9.1 68.8-.1 10.5-.1 20.8-2 30.2-6.9 7.6-3.9 13.3-9.5 17-18h-3.3z"}})])
          )
        }
      }
    